module.exports = __webpack_public_path__ + "static/img/h2.a678122.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/h2.png
// module id = YcwJ
// module chunks = 1